<template>
    <div class="home-last-winners">
	    <dynamic-marquee direction="row" :repeat="true" :reverse="true"  >
            <div class="marquee-wrapper flex-column">
                <div class="item" v-for="(item,winnersKey) in winners" :key="item.user + '_' + winnersKey">
                    <div class="left">
                        <img :src="item.image" width="60">
                    </div>
                    <div class="right">
                        <small>{{ item.user }}</small>
                        <span>{{ item.game }}</span>
                        <b>{{ item.win | toDouble }} TRY Kazandı!</b>
                    </div>
               </div>
            </div> 
	    </dynamic-marquee>
    </div>
</template>

<script>
    import DynamicMarquee from 'vue-dynamic-marquee';
    export default{
        components: {
            'dynamic-marquee' : DynamicMarquee
        },
        computed:{
            winners(){
                return this.$store.getters['slot/getWinners'];
            },
        }
    }
</script>

<style lang="scss">
    .home-last-winners{
    overflow: hidden;
    height: 60px;
    margin-top: -5px;
    position: relative;
    background-color: #253c3f;
        .marquee-wrapper {
            display: flex; 
            flex-direction: row;
            justify-content: center; 
            align-items: center; 
            width: 100%; height: 100%;
            .item{
                display: flex;
                margin-right: 10px;
                align-items: center;
                white-space: nowrap;
                .left{
                    display: flex;
                    align-items: center;
                    margin-right: 20px;
                    img{
                        border-radius: 10px;
                    }
                }
                .right{
                    display: flex;
                    flex-direction: column;
                    font-size: 12px;
                    small{
                        opacity: .6;
                    }
                    span{
                        font-weight: 600;
                        font-size: 11px;
                        margin: 1px 0;
                    }
                    b{
                        color: var(--client-c3);
                    }
                }
            }
        }
    }
</style>